import ReactDOM from 'react-dom';
import App from './App';
import WebComponentPortal from './WebComponentPortal';

import { getDataProps, Dataset } from './utils/dataProps';

const root = document.getElementById('tjt-podlet-frontpage');

if (root) {
    const props: Dataset = getDataProps();

    ReactDOM.render(
        <WebComponentPortal containerElement={root}>
            <link
                href={props.stylelink}
                media="all"
                type="text/css"
                rel="stylesheet"
            />
            <App />
        </WebComponentPortal>,
        root,
    );
}
